import { getMailboxFolderTreeData } from 'owa-folders';
import { getDefaultLogonEmailAddress } from 'owa-session-store';

/**
 * Selector for user emails of all the added shared folder users
 */
export function getSharedFolderUserEmails(userIdentity?: string): string[] {
    if (!userIdentity) {
        userIdentity = getDefaultLogonEmailAddress();
    }
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2345 (14,37): Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    // @ts-expect-error
    return getMailboxFolderTreeData(userIdentity)?.sharedFolderUserEmails;
}
